/* eslint-disable angular/di */
import * as angular from 'angular';
import 'angular-translate-loader-static-files';
import { zendeskModule } from 'go-modules/services/zendesk';
import 'go-modules/zendesk-settings';
import { goLocalizeHelperModule } from 'go-modules/translation-helper';
import { GoLocalizeHelperService, Language } from 'go-modules/translation-helper/go-localize-helper.service';
import { dashboardModule } from 'dashboard/app.module.ajs';
import { environment } from '@dashboard/environments/environment';

export const dashboardLegacyModule = angular.module('dashboardLegacy', [
	dashboardModule,
	zendeskModule,
	goLocalizeHelperModule
])
	// NOTE:
	// This was copied from `translate.config.ts` in go-modules. Any chagnes there should be synced here,
	// with the exception of the prefix for where to get the translations
	.config(['$translateProvider', '$translatePartialLoaderProvider', 'tmhDynamicLocaleProvider', (
		$translateProvider: ng.translate.ITranslateProvider,
		$translatePartialLoaderProvider: ng.translate.ITranslatePartialLoaderProvider,
		tmhDynamicLocaleProvider: tmh.tmh.IDynamicLocaleProvider
	) => {

		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate: `${environment.translationsPrefix}translations/translation/{lang}{part}?v=@@CACHEBUST@@`
		});

		tmhDynamicLocaleProvider.localeLocationPattern(`${environment.translationsPrefix}translations/locales/locale-{{locale}}.js`);
		tmhDynamicLocaleProvider.defaultLocale(Language.EN);

		// This ensures the "main" json file is loaded immediately
		$translatePartialLoaderProvider.addPart('.json');

		$translateProvider.uniformLanguageTag('bcp47');
		$translateProvider.useSanitizeValueStrategy('escapeParameters');
		$translateProvider.preferredLanguage('en');
		$translateProvider.fallbackLanguage('en');
		$translateProvider.useMissingTranslationHandler('goreactMissingTranslationHandler');
	}])
	.run(['goLocalizeHelper', (goLocalizeHelper: GoLocalizeHelperService) => {
		goLocalizeHelper.configure(Language.EN);
	}])
	.name;
